export default __webpack_public_path__ + "72f3e60.png";